<template>
  <div class="egl-elm egl-detail setting clearfix">
    <el-form-item  prop="cinemaCode" :rules="formRules.cinemaCode">
      <span slot="label">
        {{ $locale('setting.cinema.code') }}
        <template>
          <span v-if="(adminType == 'brand')"></span>
          <span v-else>(Read Only)</span>
        </template>
      </span>
      <el-input :placeholder="$locale('setting.brand.p.businesscode')" 
        v-model="detailObj.cinemaCode"
        :disabled="!editable"
        :readonly="(adminType == 'brand') ? false : true"
        @input.native="setCinemaCodeEgl" maxlength="100"></el-input>
    </el-form-item>
    <el-form-item :label="$locale('setting.cinema.ttcgcode')" prop="cinemaCodeEgl" >
      <el-input :placeholder="$locale('setting.brand.p.ttcgcode')" 
        v-model="detailObj.cinemaCodeEgl" 
        :disabled="!editable" 
        :readOnly="true" 
        class="cinema-code-text" maxlength="255"></el-input>
    </el-form-item>
    <hr class="dotted" />
    <div class="form-module-tit">{{ $locale('bookKeeping.journal') }}</div>
    <el-row :gutter="10">
      <el-col :span="8">
          <el-form-item :label="$locale('global.cinema')+'1 ('+$locale('bookKeeping.journal.subclass')+')'" prop="auxiliaryCourse1">
            <el-input :placeholder="$locale('setting.brand.p.businesscode')" v-model="detailObj.journalCinema1" />
          </el-form-item>
      </el-col>
      <el-col :span="8">
          <el-form-item :label="$locale('global.cinema')+'2 ('+$locale('bookKeeping.journal.subclass')+')'" prop="auxiliaryCourse2">
            <el-input :placeholder="$locale('setting.brand.p.businesscode')" v-model="detailObj.journalCinema2" />
          </el-form-item>
      </el-col>
      <el-col :span="8">
          <el-form-item :label="$locale('global.cinema')+'3 ('+$locale('bookKeeping.journal.subclass')+')'" prop="customer">
            <el-input :placeholder="$locale('setting.brand.p.businesscode')" v-model="detailObj.journalCinema3" />
          </el-form-item>
      </el-col>
    </el-row>
    <el-form-item :label="$locale('global.status')" prop="businessStatus" :rules="formRules.businessStatus">
      <div class="cinema-status">
        <el-select v-model="detailObj.businessStatus">
          <el-option
            v-for="obj in businessOptions"
            :key="obj.val"
            :value="obj.val"
            :label="obj.text"
          ></el-option>
        </el-select>
      </div>
    </el-form-item>
    <el-row :gutter="10">
      <el-col :span="6">
          <el-form-item :label="$locale('bookKeeping.journal.reprintCountCC')" prop="reprintCountCC">
            <el-input v-model.number="detailObj.cinemaSetting.reprintCountCC" />
          </el-form-item>
      </el-col>
      <el-col :span="6">
          <el-form-item :label="$locale('bookKeeping.journal.reprintCountPOS')" prop="reprintCountPOS">
            <el-input v-model.number="detailObj.cinemaSetting.reprintCountPOS" />
          </el-form-item>
      </el-col>
      <el-col :span="6">
          <el-form-item :label="$locale('bookKeeping.journal.reprintInvoiceCountPOS')" prop="reprintInvoiceCountPOS">
            <el-input v-model.number="detailObj.cinemaSetting.reprintInvoiceCountPOS" />
          </el-form-item>
      </el-col>
      <el-col :span="6">
          <el-form-item :label="$locale('bookKeeping.journal.reprintReceiptCountPOS')" prop="reprintReceiptCountPOS">
            <el-input v-model.number="detailObj.cinemaSetting.reprintReceiptCountPOS" />
          </el-form-item>
      </el-col>
    </el-row>
    <hr class="dotted" />
    <div class="form-module-tit">{{ $locale('setting.cinema.tmsSetting') }}</div>
    <el-row :gutter="10">
      <el-col :span="8">
        <el-form-item :label="$locale('setting.cinema.tmsCinemaServer')" prop="tmsCinemaServer">
          <el-input :placeholder="$locale('theatre.p.input')"
            v-model="detailObj.tmsCinemaServer"
            :disabled="!editable" maxlength="255"></el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "cinemaSystemSetting",
  props: {
    detailObj: Object,
    serial: {
      type: String,
      default: () => {
        return "001";
      }
    }
  },
  data() {
    return {
      adminType: window.localStorage.getItem("adminType"),
      editable: true,
      action: "create",
      formRules: {
        cinemaCode: [ {
          required: true,
          message: this.$locale("setting.cinema.err.code"),
          trigger: "blur",
        } ],
        businessStatus: [ {
          required: true,
          message: this.$locale("setting.cinema.err.status"),
          trigger: "change",
        } ],
      },
    };
  },
  computed: {
    businessOptions() {
      const optionTranslate = {
        pre_opening: this.$locale("setting.cinema.status.preopen"),
        business: this.$locale("setting.cinema.status.open"),
        close: this.$locale("setting.cinema.status.close"),
        rest: this.$locale("setting.cinema.status.rest"),
      };
      let dictionary = window.localStorage.getItem("dictionary") || "";
      let options = [];

      if (dictionary != "") {
        let arr = [];

        dictionary = JSON.parse(dictionary);

        arr = Object.keys(dictionary.movieData.BusinessStatus);

        arr.map(val => {
          let text = optionTranslate[val] ? optionTranslate[val] : val;

          options.push({
            val: val,
            text: text,
          });
        });
      }

      return options;
    },
  },
  methods: {
    setCinemaCodeEgl() {
      if(this.detailObj.cinemaCode != '') {
        this.detailObj.cinemaCodeEgl = this.detailObj.brandCode + "-" + this.detailObj.cinemaCode
      } else {
          this.detailObj.cinemaCodeEgl = this.detailObj.brandCode
      }
    },
  },
};
</script>
